export enum StageViewModeEnum {
  PUBLISHED = 'PUBLISHED',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
}
